import { Link } from "react-router-dom";
import { exams } from "@/data/content";
import {useSiteSettingsContext} from "@/hooks/useSiteSettingsContext";
import PageShell from "@/components/feature/PageShell";
import SiteCTA from "@/components/feature/SiteCTA";
import Reveal from "@/components/base/Reveal";

export default function Sinavlar() {
  const { settings } = useSiteSettingsContext();
  const name = settings.siteName || "DersDinle";
  const crumbs = [{ label: "Ana Sayfa", href: "/" }, { label: "Sınavlar" }];

  return (
    <PageShell crumbs={crumbs}>
      {/* Hero */}
      <section className="bg-background-100 px-4 md:px-6 lg:px-10 py-14 md:py-20 border-b border-background-200">
        <div className="max-w-6xl mx-auto">
          <Reveal>
            <span className="inline-flex items-center gap-2.5 text-xs font-semibold uppercase tracking-[0.14em] text-primary-700">
              <span className="w-5 h-px bg-accent-500" aria-hidden="true"></span>
              Sınavlara Hazırlık
            </span>
            <h1 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-foreground-950 leading-tight max-w-2xl">
              Hedef sınavına {name} ile hazırlan
            </h1>
            <p className="mt-5 text-base md:text-lg text-foreground-600 leading-relaxed max-w-2xl">
              Sınavını seç; konu anlatımı, kişisel soru seti, deneme ve gelişim analiziyle
              planlı bir hazırlık yap.
            </p>
          </Reveal>
        </div>
      </section>

      {/* Sınav kartları */}
      <section className="bg-background-50 px-4 md:px-6 lg:px-10 py-14 md:py-20">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {exams.map((exam) => (
              <Reveal key={exam.slug}>
                <Link
                  to={`/sinavlar/${exam.slug}`}
                  className="flex flex-col h-full p-6 rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 transition-colors group"
                >
                  <div className="flex items-center justify-between gap-3">
                    <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-primary-700 bg-primary-100 rounded-full px-3 py-1">
                      {exam.shortName}
                    </span>
                    <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 group-hover:bg-accent-100 group-hover:text-accent-700 transition-colors">
                      <i className="ri-arrow-right-line" aria-hidden="true"></i>
                    </span>
                  </div>
                  <h2 className="mt-4 font-heading font-semibold text-base text-foreground-950">
                    {exam.fullName}
                  </h2>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">
                    {exam.description}
                  </p>
                  <span className="mt-4 text-xs font-medium text-foreground-500">
                    {exam.stats.slice(0, 3).map((s) => s.value).join(" · ")}
                  </span>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <SiteCTA />
    </PageShell>
  );
}